import { issueClassificationUrl } from "./constants";
import base from "../middlewares/interceptors";
import { IIssueClassificationPayload } from "../types/Classification";

/**
 * Get classification by ID
 */
export const getIssueClassificationById = async (classificationId: string) => {
  try {
    const response = await base.get(`${issueClassificationUrl}/${classificationId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching classification by ID:", error);
    throw error;
  }
};

/**
 * Add new classification
 */
export const addIssueClassification = async ({ payload }: { payload: IIssueClassificationPayload }) => {
  try {
    const response = await base.post(`${issueClassificationUrl}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error adding classification:", error);
    throw error;
  }
};

/**
 * Update classification
 */
export const updateIssueClassification = async ({
  currentClassificationId,
  payload,
}: {
  currentClassificationId: string;
  payload: IIssueClassificationPayload;
}) => {
  try {
    const response = await base.put(
      `${issueClassificationUrl}/${currentClassificationId}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error updating classification:", error);
    throw error;
  }
};

/**
 * Delete classification
 */
export const deleteIssueClassification = async (classificationId: string) => {
  try {
    const response = await base.delete(
      `${issueClassificationUrl}/${classificationId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting classification:", error);
    throw error;
  }
};

/**
 * Reactivate classification
 */
export const reactivateIssueClassification = async (classificationId: string) => {
  try {
    const response = await base.put(
      `${issueClassificationUrl}/${classificationId}/reactivate`
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating classification:", error);
    throw error;
  }
};

/**
 * Get paginated issue classifications list
 */
export const getPaginatedIssueClassifications = async (
  page: number = 1,
  size: number = 25,
  searchTerm?: string,
  signal?: AbortSignal,
  filterIds?: string,
  isActive?: boolean
) => {
  try {
    let url = `${issueClassificationUrl}/pages?page=${page}&size=${size}`;

    if (filterIds && filterIds.trim().length > 0) {
      url += `&issue_classification_filter_ids=${encodeURIComponent(filterIds.trim())}`;
    }

    if (searchTerm && searchTerm.trim().length >= 3) {
      url += `&issue_classification_name=${encodeURIComponent(searchTerm.trim())}`;
    }

    if (isActive !== undefined) {
      url += `&is_active=${isActive}`;
    }

    const response = await base.get(url, { signal });
    return response.data;
  } catch (error) {
    console.error("Error fetching paginated issue classifications:", error);
    throw error;
  }
};

